exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row dl {\n  width: calc(24.5%);\n}\n.row dl dt {\n  min-width: 80px;\n}\n.row span.center {\n  min-width: 70px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/sysman/src/app/sysman-sddp-device-detail/sysman-sddp-device-detail.component.less
// module id = 1476
// module chunks = 2